export default __webpack_public_path__ + "ea3d65a7b9829c9090b0a80c6e260a4a.woff";